var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailGraphicsError520(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430 320"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.44h430V320H0z",
    "data-name": "Layer 1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 75",
    cx: 169.26,
    cy: 256.67,
    r: 10.47,
    fill: "#d19974"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 778",
    d: "M200.66 196.57c-17.83 8-20.8 21.29-24 44.89a274.07 274.07 0 00-2.5 42.66s10.47 2.84 23.12 5.11 26.68 0 26.68 0-7.7-33.61-8.85-47.77-3.36-30.39-3.36-30.39z",
    fill: "#0086ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 932",
    fill: "#005da3",
    d: "M166.814 246.029l17.83-36.587 11.497 5.602-17.83 36.588z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 781",
    d: "M242.93 235.49l1.16 13.51h-20.27l-18.48-22.57 6.5-9.64 13.79 19.4z",
    fill: "#0086ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.75 221.32s9.82 15.57 13.88 18.62 11.85 3.06 11.85 3.06l10.84-.68-.23 6.73h-20.27l-15.39-17.23z",
    fill: "#005da3"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 73",
    cx: 249.05,
    cy: 241.76,
    r: 10.47,
    fill: "#f2c09e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 782",
    d: "M254.27 236.85h8.78l29.07 60.08 26.19 4.92v7.76h-35.54l3.23-12.68-26.13-54.66h-5.61z",
    fill: "#008ca3"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 76",
    cx: 283.23,
    cy: 306.68,
    r: 4.65,
    fill: "#072939"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 830"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 933",
    d: "M51 250.25l1.16-11.57 11.63 1.22a2.33 2.33 0 012.07 2.56l-.73 7a2.32 2.32 0 01-2.55 2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdb177",
    d: "M43.324 247.387l.131-1.153 7.989.906-.13 1.153zM43.313 241.718l.14-1.151 8.716 1.062-.14 1.152z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 934",
    fill: "#6bd5ed",
    d: "M5.94 239.89h19.11V259H5.94z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.49,
    cy: 249.45,
    r: 5.97,
    fill: "#008ca3",
    "data-name": "Ellipse 77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.65 252a.58.58 0 01-.58-.58v-3.49a.58.58 0 011.16 0v3.49a.58.58 0 01-.58.58zM17.14 252a.58.58 0 01-.58-.58v-3.49a.58.58 0 011.16 0v3.49a.58.58 0 01-.58.58z",
    fill: "#072939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.26 205.89s-4.14 13.58-4.43 26.58 1.47 47.25 1.47 47.25l.95 9.51-23.12-5.11s-.57-23.3 2.09-40.43 4.72-26 6.5-31.3 10-13 10-13z",
    fill: "#005da3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.36 299.84s12.64-6.91 19.26-5.46a23.65 23.65 0 0111.06 6.15l-27.16 12s-3.11-3-3.79-5.87.63-6.82.63-6.82z",
    fill: "#0086ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.16 298.9a15.26 15.26 0 004.28 4.59c2.66 1.76 10.14-1.06 13.47-2.08a42.69 42.69 0 006.92-3l2.85 2.13-27.16 12a38.76 38.76 0 01-3.79-5.87c-.82-2 .63-6.77.63-6.77z",
    fill: "#005da3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.41 286.93s11.55 8.6 13 15.23a23.55 23.55 0 01-1 12.61l-22.19-19.68s1.45-4.09 3.75-5.9 6.44-2.26 6.44-2.26z",
    fill: "#0086ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.78 288.7s-.05 1.61 3.4 6.74 14.27 13.85 14.27 13.85l-1 5.48-22.19-19.68a34.2 34.2 0 012.27-4.87 3.27 3.27 0 013.25-1.52z",
    fill: "#005da3"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 74",
    cx: 204.73,
    cy: 183.99,
    r: 25,
    fill: "#f2c09e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.46 204.87a25.16 25.16 0 004.26-3.58 24.7 24.7 0 01-25.45-40.53 25.16 25.16 0 00-6.15 3 24.71 24.71 0 0027.34 41.16zM224.41 185.79s2-2.69 3.36-1.81 1.59 3.69 1.59 3.69z",
    fill: "#d19974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.29 246.06s.4 22.64 1.18 30.71 3.94 16.54 6.9 18.9 16.14.59 16.14.59l-2.36-4.13s-3.94-2.56-8.86-12-9.65-26.78-9.65-26.78z",
    fill: "#6bd5ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.26 258.07c.79 6.49 3.74 20.28 7.29 26.38s12.69 7.47 12.69 7.47l2.27 4.34a69.88 69.88 0 01-12 .59c-4.73-.39-5.12-2-6.69-3.93s-4.34-15.16-4.73-18.91-.79-27.95-.79-27.95z",
    fill: "#008ca3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.13 244.8c-5.65 2.2-31 13.66-45.34 12.48s-30.51-9.65-45.28-11.22-31.9 27.36-45.68 28.94-9.84-46.07-20.08-47.06-7.09 53.95-15 54.15-7.87-24.81-13-30.13-16.74-6.3-16.74-6.3",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.163
  }))));
}
export default SvgDetailGraphicsError520;